import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import api from '../../api/axios';

const UserFormModal = ({ show, onHide, onCreated, initialData }) => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    role: 'MOZO',
  });

  useEffect(() => {
    if (initialData) {
      setForm({
        name: initialData.name,
        email: initialData.email,
        password: '',
        role: initialData.role
      });
    } else {
      setForm({ name: '', email: '', password: '', role: 'MOZO' });
    }
    setError('');
  }, [initialData]);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(form.email)) {
      setError('El email ingresado no es válido.');
      setLoading(false);
      return;
    }

    try {
      if (initialData) {
        // Edición
        await api.put(`/users/staff/${initialData.id}`, {
          name: form.name,
          email: form.email,
          role: form.role,
        });
      } else {
        // Creación
        const business = JSON.parse(localStorage.getItem('business'));
        await api.post('/users/staff', {
          ...form,
          business_id: business?.id
        });
      }

      onCreated(); // recargar usuarios
      onHide();    // cerrar modal
    } catch (err) {
      if (err.response?.status === 409) {
        setError('El email ya está en uso.');
      } else {
        setError('Ocurrió un error inesperado.');
      }
      console.error('Error en formulario:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} backdrop="static" keyboard={!loading}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{initialData ? 'Editar Usuario' : 'Nuevo Usuario'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Form.Control
              autoFocus
              name="name"
              value={form.name}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Contraseña</Form.Label>
            <Form.Control
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              placeholder={initialData ? '(opcional)' : ''}
              required={!initialData}
              disabled={loading}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Rol</Form.Label>
            <Form.Select
              name="role"
              value={form.role}
              onChange={handleChange}
              disabled={loading}
            >
              <option value="MOZO">Mozo</option>
              <option value="CAJERO">Cajero</option>
            </Form.Select>
          </Form.Group>

          {error && (
            <Alert variant="danger" className="mt-3">
              {error}
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={loading}>
            Cancelar
          </Button>
          <Button type="submit" variant="primary" disabled={loading}>
            {loading
              ? 'Guardando...'
              : initialData
              ? 'Actualizar'
              : 'Guardar'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default UserFormModal;
